// The talent price floor on the number pad ("Minimum $5" class since
// 2026-10-30, or the talent's own line). The floor itself is
// minRequestPriceFor (utils/payinConfig.ts, the server mirror);
// these two helpers are the pad's whole behaviour: the line turns amber while
// the typed amount sits under it, and Done lifts it up to the floor. Free (0)
// is never lifted — it is a real price wherever the pad allows it.
import { minRequestPriceFor, type TierTalent } from "./payinConfig";

const parse = (draft: string) => Number(String(draft).trim().replace(",", "."));

/** Is the typed draft a real, non-free amount under the floor? */
export function belowFloor(draft: string, currency?: string | null, talent?: TierTalent): boolean {
  if (String(draft).trim() === "") return false;
  const n = parse(draft);
  return Number.isFinite(n) && n > 0 && n < minRequestPriceFor(currency, talent);
}

/** Done on the pad: an amount under the floor becomes the floor; anything else is unchanged. */
export function liftToFloor(n: number, currency?: string | null, talent?: TierTalent): number {
  const min = minRequestPriceFor(currency, talent);
  return Number.isFinite(n) && n > 0 && n < min ? min : n;
}
